import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '@app/types/country';
import { Organization } from '@app/types/organization.enum';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OeLocationService {
  private api = environment.oeLocationService;

  constructor(private http: HttpClient) {}

  getContactPhoneByCountryIsoCode(
    countryIsoCode: string,
    organization?: Organization
  ): Observable<string> {
    const params = new HttpParams().set('isocode', countryIsoCode);
    return this.http
      .get<Array<Country>>(`${this.api}/countries`, { params })
      .pipe(
        map((countries) => {
          if (countries.length !== 1) {
            return null;
          }

          const country = countries[0];
          if (!country.phone) {
            return null;
          }

          if (organization === Organization.NextU) {
            return country.phone.nextuContactPhone;
          }

          return country.phone.oeContactPhone;
        })
      );
  }
}
